import React, { FC, useEffect, useState } from 'react';
import MainLayout from 'components/main-layout/MainLayout';
import API from 'core/Api';
import Tabs from 'components/tabs/Tabs';
import Tab from 'components/tabs/Tab';
import { useTranslation } from 'react-i18next';
import MicrosoftAuthImage from 'assets/MicrosoftAuth.jpg';
import GoogleAuthImage from 'assets/GoogleAuth.svg';
import { updateUserData } from 'utils/userDataSync';
import TotpGoogleContent from './components/totpGoogle/Content';
import TotpMicrosoftContent from './components/totpMicrosoft/Content';

/**
 * This page is shown if the user has NOT set
 * his 2FA and is being redirected here
 */
const TwoFactorAuthActivate: FC = () => {
  const [qrCode, setQRCode] = useState('');
  const [secretKey, setSecretKey] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('totpGoogle');

  const { t } = useTranslation();

  useEffect(() => {
    API.post('auth/2fa-set')
      .then(response => {
        setQRCode(response.data?.qr_code_url);
        setSecretKey(response.data?.secret);

        return updateUserData();
      })
      .catch(err => console.error(err))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <MainLayout
      isLoading={isLoading}
      title={t('twoFA.activateTitle')}
    >
      <Tabs>
        <Tab
          isActive={activeTab === 'totpGoogle'}
          onClick={() => setActiveTab('totpGoogle')}
        >
          <img
            src={GoogleAuthImage}
            alt="Google Authenticator"
            style={{ width: 20, height: 20, marginRight: '0.5rem' }}
          />
          {t('auth.twoFA.googleAuth')}
        </Tab>
        <Tab
          isActive={activeTab === 'totpMicrosoft'}
          onClick={() => setActiveTab('totpMicrosoft')}
        >
          <img
            src={MicrosoftAuthImage}
            alt="Microsoft Authenticator"
            style={{ width: 20, height: 20, marginRight: '0.5rem' }}
          />
          {t('auth.twoFA.microsoftAuth')}
        </Tab>
      </Tabs>
      {activeTab === 'totpGoogle' && (
        <TotpGoogleContent
          qrCode={qrCode}
          secretKey={secretKey}
        />
      )}
      {activeTab === 'totpMicrosoft' && (
        <TotpMicrosoftContent
          qrCode={qrCode}
          secretKey={secretKey}
        />
      )}
    </MainLayout>
  );
};

export default TwoFactorAuthActivate;
